export const USER_VIEW_SET = 'USER_VIEW_SET';
export const USER_PREV_PAGE = 'USER_PREV_PAGE';